// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"787a3d7c","355":"bc6fe48e","395":"cbd6f3d8","453":"03346f77","455":"cfabb115","977":"5a4c08f0"}[chunkId] + ".chunk.js";
};